import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Auth } from 'aws-amplify'
import { get } from 'lodash'
import { Field, Formik, Form } from 'formik'
import * as Yup from 'yup'
import { Loading, Button, FormikInput, FormikSelect, FlexContainer } from '../../common'
import CreateOrderComment from '../../graphql/createOrderComment'

class RegisterCallForm extends Component {
  state = {
    loading: false,
    currentUserInfo: {}
  }

  async componentDidMount () {
    try {
      this.setState({ loading: true })
      const currentUserInfo = await Auth.currentSession()
      this.setState({ currentUserInfo, loading: false })
    } catch (error) {
      console.log(error, this.setState({ loading: false }))
    }
  }

  _onSubmitForm = (values, { setSubmitting }) => {
    const { onClose, createComment, orderId } = this.props
    const { contactType, phone, comment } = values
    setSubmitting(true)
    createComment({
      variables: {
        input: {
          phone,
          user: get(values, 'user'),
          contactType: get(contactType, 'value'),
          idOrder: orderId,
          comment: `+56 ${phone} - ${comment}`,
          dataSource: 'Web'
        }
      }
    }).then(() => {
      setSubmitting(false)
      onClose()
    }).catch(console.error)
  }

  render () {
    const { currentUserInfo, loading } = this.state
    const { onClose, customer } = this.props
    const { email } = get(currentUserInfo, 'idToken.payload', { email: '' })
    return (
      <Loading loading={loading}>
        <Formik
          onSubmit={this._onSubmitForm}
          onReset={onClose}
          validationSchema={
            Yup.object().shape({
              phone: Yup.string()
                .min(9, 'form.validations.phone_length.min')
                .max(9, 'form.validations.phone_length.max')
                .required('form.validations.required'),
              comment: Yup.string().required('form.validations.required'),
              contactType: Yup.object().shape({
                value: Yup.string().required('form.validations.required')
              })
            })
          }
          initialValues={{
            user: email,
            phone: get(customer, 'phone').replace('+56', ''),
            contactType: '0',
            comment: ''
          }}
          render={({ isSubmitting, isValid, errors, handleSubmit }) => (
            <FlexContainer flex={1}>
              <Form onSubmit={handleSubmit} style={{ flex: 1 }}>
                <Field
                  name='user'
                  label='Usuario'
                  component={FormikInput}
                  disabled
                />
                <Field
                  name='phone'
                  label='Teléfono'
                  component={FormikInput}
                  codePrefix='+56'
                />
                <Field
                  component={FormikSelect}
                  label='Tipo de contacto'
                  name='contactType'
                  options={[{ label: 'Con contacto', value: 1 }, { label: 'Sin contacto', value: 0 }]}
                />
                <Field
                  component={FormikInput}
                  name='comment'
                  textArea
                  label='Ingrese un motivo de contacto'
                />
                <FlexContainer style={{ position: 'absolute', bottom: 0, width: '100%', left: 0, borderTop: '1px solid #eaeaea' }} justify='flex-end' padding={18}>
                  <Button htmlType='reset' link text='Cancelar' width={100} /> {/** TODO: // crear un component FormButton (con el width de 95px)*/}
                  <Button htmlType='submit' loading={isSubmitting} text='Guardar' width={100} maxWidth='95px' />
                </FlexContainer>
              </Form>
            </FlexContainer>

          )}
        />
      </Loading>
    )
  }
}

RegisterCallForm.propTypes = {
  orderId: PropTypes.string,
  onClose: PropTypes.func,
  createComment: PropTypes.func,
  callHistoryType: PropTypes.string,
}

export default (props) => {
  const callHistoryType = props.callHistoryType;

  return<CreateOrderComment callHistoryType={callHistoryType}>
    {({ updateFn, loading }) => (
      <RegisterCallForm {...props} createComment={updateFn} />
    )}
  </CreateOrderComment>
}
